<template>
    <div id="benefits">
        <!--=====================================-->
        <!--=       Why Choose Area Start       =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-12 ">
                        <div class="section-heading heading-left">
                            <span class="subtitle primary">Beneficios</span>
                            <h2 class="font-weight-100">Beneficios para tu <span class="bold primary">referido</span>.</h2>
                        </div>
                    </div>
                    <!-- BENEFICIOS PARA TU REFERIDO -->
                    <div class="row ">
                        <div class="col-lg-6">
                            <div class="why-choose-us">
                                <div class="accordion" id="choose-accordion">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true"
                                                aria-controls="collapseOne">
                                                Rendimiento
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show"
                                            aria-labelledby="headingOne" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Rendimiento histórico superior a CETES. <router-link :to="{name:'yieldPage'}" class="rg-a">Conoce más</router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true"
                                                aria-controls="collapseTwo">
                                                <span class="icon sun"></span>Diversificación
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse show"
                                            aria-labelledby="headingTwo" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Construye un portafolio pulverizado en cientos de créditos.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                aria-expanded="true" aria-controls="collapseThree">
                                                <span class="icon money"></span>Seguridad
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse show"
                                            aria-labelledby="headingThree" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Invierte en una plataforma fintech regulada. <a @click.stop="redirectThirdSite('http://www.dof.gob.mx/nota_detalle.php?codigo=5651691&fecha=11/05/2022', ThirdSiteText)" class="rg-a">Conoce más</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingFour">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                aria-expanded="true" aria-controls="collapseFour">
                                                <span class="icon face"></span>Experiencia
                                            </button>
                                        </h2>
                                        <div id="collapseFour" class="accordion-collapse collapse show"
                                            aria-labelledby="headingFour" data-bs-parent="#choose-accordion">
                                            <div class="accordion-body">
                                                Goza de la rapidez y simpleza de una plataforma completamente digital.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-6 offset-xl-1 mb-5">
                            <div class="why-choose-us mb--30">
                                <div class="why-choose-thumb">
                                    <img :src="`${imgBase}promoters-1.png`"
                                        alt="Office">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- BENEFICIOS PARA TU REFERIDO -->

                    <!-- BENEFICIOS PARA TI -->
                    <div class="row mb--100">
                        <div class="col-10">
                            <div class="section-heading heading-left">
                                <h2 class="font-weight-100 mb-3">Beneficios para <span class="bold primary">ti</span>.</h2>
                            </div>
                        </div>

                        <div class="col-12">
                            <!-- web-destinations -->
                            <div class="row web-destinations">
                                <div class="col-sm-12 col-md-6 col-lg-4">
                                    <div class="p-5 mb-2 bg-white-green">
                                        <h5 class="bold">Ingresos pasivos.</h5>
                                        <p>
                                            Mientras tus referidos sigan invirtiendo 
                                            con nosotros, tú seguirás cobrando 
                                            mensualmente tú comisión.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4">
                                    <div class="p-5 mb-2 bg-white-green">
                                        <h5 class="bold">Alta de referidos.</h5>
                                        <p>
                                            Tus referidos podrán registrase 
                                            con una liga o código único. 
                                            Próximamente, podrás dar de alta 
                                            referidos directamente desde el portal.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4">
                                    <div class="p-5 mb-2 bg-white-green">
                                        <h5 class="bold">Mantenimiento de referidos.</h5>
                                        <p>
                                            Próximamente, desde el portal 
                                            podrás ayudarle a tu referido a gestionar 
                                            su cuenta (invertir y configurar planes 
                                            de inversión).
                                        </p>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-4">
                                    <div class="p-5 mb-2 bg-white-green">
                                        <h5 class="bold">Herramientas efectivas.</h5>
                                        <p>
                                            Acceso a presentaciones y diversos 
                                            materiales de apoyo. En caso de ser 
                                            necesario, te podríamos acompañar 
                                            virtualmente en la prospección de tus 
                                            referidos.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- MOBILE -->
                            <div class="mobile-destinations">
                                <slick :options="slickOptions">
                                    <div class="col-sm-12 col-md-6 col-lg-4">
                                        <div class="p-5 mb-2 bg-white-green">
                                            <h5 class="bold">Ingresos pasivos.</h5>
                                            <p>
                                                Mientras tus referidos sigan invirtiendo 
                                                con nosotros, tú seguirás cobrando 
                                                mensualmente tú comisión.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-4">
                                        <div class="p-5 mb-2 bg-white-green">
                                            <h5 class="bold">Alta de referidos.</h5>
                                            <p>
                                                Tus referidos podrán registrase 
                                                con una liga o código único. 
                                                Próximamente, podrás dar de alta 
                                                referidos directamente desde el portal.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-4">
                                        <div class="p-5 mb-2 bg-white-green">
                                            <h5 class="bold">Mantenimiento de referidos.</h5>
                                            <p>
                                                Próximamente, desde el portal 
                                                podrás ayudarle a tu referido a gestionar 
                                                su cuenta (invertir y configurar planes 
                                                de inversión).
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-4">
                                        <div class="p-5 mb-2 bg-white-green">
                                            <h5 class="bold">Herramientas efectivas.</h5>
                                            <p>
                                                Acceso a presentaciones y diversos 
                                                materiales de apoyo. En caso de ser 
                                                necesario, te podríamos acompañar 
                                                virtualmente en la prospección de tus 
                                                referidos.
                                            </p>
                                        </div>
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>
                    <!-- BENEFICIOS PARA TI -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Slick from 'vue-slick';
export default {
    name: "Benefits",
    components: {
        Slick
    },
    data() {
        return {
            slickOptions: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            },
            imgBase: "https://cdn.redgirasol.com/nuevo_portal/fotografias/foto-"
        }
    }
}

</script>

<style scoped>

.bg-white-green {
    max-height: 18rem;
    background-repeat: round;
}

.mobile-destinations {
    display: none;
}

.web-destinations {
    display: flex;
}
@media only screen and (max-width: 575px) {
    .mobile-destinations {
        display: block;
    }

    .web-destinations {
        display: none;
    }
}

</style>